import styled from 'styled-components';
import { Fade } from '~/styles/animations';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${(props) => props.theme.spacing.xSmall} 0;
  flex: 1;
  position: relative;

  span {
    font-size: 12px;
    color: ${(props) => props.theme.palette.danger.main};
    margin: 2px;
    position: absolute;
    bottom: -6px;
    animation: ${Fade} linear forwards 0.5s;
  }

  label {
    margin-left: 2px;
    font-weight: normal;
    color: ${(props) => props.theme.palette.gray1};
    text-transform: uppercase;
  }

  textarea {
    padding: ${(props) =>
      `${props.theme.spacing.xSmall} ${props.theme.spacing.base}`};
    border: 1px solid
      ${(props) =>
        props.error
          ? props.theme.palette.danger.main
          : props.theme.palette.gray4};
    transition: all ease 0.2s;
    font-size: 14px;
    border-radius: 4px;
    outline: none;
    min-height: 140px;
    resize: none;
    font-family: Rubik;
    width: 100%;

    &::placeholder {
      font-family: Rubik;
      font-size: 14px;
      color: #6b7786;
    }
  }
`;
